export default __webpack_public_path__ + "static/media/compiegnemini.1ef4caf1.jpg";